import React, { useEffect, useState } from 'react'

import './styles.scss'
import { configurations } from '../../api'
import { ButtonTag } from 'components/Form'
import { getStaticImage } from 'utils/statics'
import ModalDelete from 'components/ModalDelete'
import { toastMessage } from 'utils/messages'
import ModalPosterQR from './ModalPosterQR'
import QRCodeWidgetCreator from './QRCodeWidgetCreator'
import { lang } from 'utils/helpers'
const _ = require('lodash')

const QRCodeEdit = (props) => {
  const { channels, qrPosters: qrPostersExternal, getAllQrPosterExternal, onDataQRToWidget } = props
  const [qrPosters, setQrPosters] = useState(qrPostersExternal || [])
  const [qrPosterIdToEdit, setQrPosterIdToEdit] = useState('')
  const [dataToEdit, setDataToEdit] = useState(null)
  const [qrPosterIdToRemove, setQrPosterIdToRemove] = useState(null)
  const [isOpenPosterQR, setIsOpenPosterQR] = useState(false)
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState(false)
  const [channelsByQrPoster, setChannelsByQrPoster] = useState([])
  const [detailsInfoPosterQr, setDetailsInfoPosterQR] = useState({})
  const [isDisplayPosterQR, setIsDisplayPosterQR] = useState(false)
  const [loading, setLoading] = useState(true)
  const [removing, setRemoving] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState({})
  const [isSubmittingDownload, setIsSubmittingDownload] = useState({})
  const qrPosterApi = configurations.channels

  useEffect(() => {
    getAllQR()
  }, [])

  useEffect(() => {
    if (qrPosterIdToEdit) getByIdQrPoster(qrPosterIdToEdit)
  }, [qrPosterIdToEdit])

  useEffect(() => {
    if (!dataToEdit) {
      setQrPosterIdToEdit('')
      getAllQR()
    }
  }, [dataToEdit])

  const toggleRemoveModal = (posterId) => {
    setIsOpenRemoveModal(!isOpenRemoveModal)
    if (posterId) {
      setQrPosterIdToRemove(posterId)
    } else {
      setQrPosterIdToRemove('')
    }
  }

  const getAllQR = async () => {
    try {
      setLoading(true)
      const { data } = await qrPosterApi.getAllQRPoster()
      if (data?.length) setQrPosters(data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getByIdQrPoster = async (id) => {
    try {
      const { data } = await qrPosterApi.getByIdQRPoster(id)
      if (data) setDataToEdit(data)
    } catch (error) {
      setDataToEdit(null)
      console.error(error)
    }
  }

  const onCopyQRToWidget = async (qrId) => {
    try {
      const { data } = await qrPosterApi.getByIdQRPoster(qrId)
      if (!data) return
      onDataQRToWidget(data)
    } catch (error) {
      console.error(error)
    }
  }

  const getByIdPosterQRToPreview = async (id, idx, display) => {
    try {
      display
        ? setIsSubmitting({ ...isSubmitting, [idx]: true })
        : setIsSubmittingDownload({ ...isSubmittingDownload, [idx]: true })
      const { data } = await qrPosterApi.getByIdQRPoster(id)
      if (data) {
        setDetailsInfoPosterQR(data)
        let _channelsSelected = []
        let _channelList = _.cloneDeep(channels)
        const qrPosterResult = data
        qrPosterResult.channels.forEach(it => {
          _channelList.forEach(it2 => {
            if (it2._id === it.identifier) {
              _channelsSelected.push({ ...it2 })
            }
          })
        })
        setIsDisplayPosterQR(display)
        setChannelsByQrPoster(_channelsSelected)
        setIsOpenPosterQR(true)
        setTimeout(() => setIsSubmittingDownload({ ...isSubmittingDownload, [idx]: false }), 3000)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsSubmitting({ ...isSubmitting, [idx]: false })
    }
  }

  const onDelete = async () => {
    try {
      setRemoving(true)
      await qrPosterApi.removeQRPoster(qrPosterIdToRemove)
      getAllQR()
      getAllQrPosterExternal()
      toastMessage(lang('channels_message_success_qr_poster'))
    } catch (error) {
      toastMessage(lang('channels_message_error_generic'), 'error')
      console.error(error)
    } finally {
      setRemoving(false)
      setQrPosterIdToRemove('')
      setIsOpenRemoveModal(false)
    }
  }

  return (
    <div className='web-widget-edit'>
      {qrPosterIdToEdit ? (
        <QRCodeWidgetCreator
          key='QrPosterCreatorEdit'
          channels={channels}
          dataToEdit={dataToEdit}
          setDataToEdit={setDataToEdit}
          getAllQrPosterExternal={getAllQrPosterExternal}
        />
      ) : (
        <>
          <h1>{lang('channels_poster_qr_edit')}</h1>
          <legend>{lang('channels_poster_qr_modal_subtitle_edit')}</legend>
          <div className='widgets-list-wrapper'>
            {qrPosters.length ? qrPosters.map((it, idx) => {
              return (
                <div key={`key-${idx}`} className='widgets-list'>
                  <div className='name-wrapper'>
                    {it.name || it.token}
                  </div>
                  <div className='buttons-wrapper'>
                    <div className='buttons-tags-qr'>
                      <ButtonTag className='button-tag-download' value={lang('dashboard_download')} onClick={() => getByIdPosterQRToPreview(it._id, idx, false)} isSubmitting={_.get(isSubmittingDownload, [idx]) || false} />
                      <ButtonTag className='button-tag-preview-qr' value={lang('dashboard_preview')} onClick={() => getByIdPosterQRToPreview(it._id, idx, true)} isSubmitting={_.get(isSubmitting, [idx]) || false} />
                    </div>
                    <div className='buttons-icons'>
                      <div title={lang('tooltip_sms_clone_qr_poster_to_widget')}>
                        <img
                          src={getStaticImage('/icons/orange-brand/clonar.svg')}
                          alt={lang('tooltip_sms_clone_qr_poster_to_widget')}
                          onClick={() => onCopyQRToWidget(it._id)}
                        />
                      </div>
                      <div>
                        <img
                          src={getStaticImage('/icons/orange-brand/icon-edit.svg')}
                          alt={lang('tooltip_sms_edit_qr_poster')}
                          onClick={() => setQrPosterIdToEdit(it._id)}
                        />
                      </div>
                      <div>
                        <img
                          src={getStaticImage('/icons/orange-brand/icon-delete.svg')}
                          alt={lang('tooltip_sms_delete_qr_poster')}
                          onClick={() => toggleRemoveModal(it._id)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )
            }) : (
              <span className='no-widget-list'>{lang(loading ? 'channels_poster_qr_loading' : 'channels_poster_qr_not_created')}</span>
            )}
          </div>
        </>
      )}
      {isOpenPosterQR ? (
        <ModalPosterQR
          isOpen={isOpenPosterQR}
          toggle={() => setIsOpenPosterQR(!isOpenPosterQR)}
          channels={channelsByQrPoster}
          configPoster={detailsInfoPosterQr}
          isDisplay={isDisplayPosterQR}
        />
      ) : null}
      <ModalDelete
        isOpen={isOpenRemoveModal}
        toggle={toggleRemoveModal}
        header={lang('channels_remove_qr_poster')}
        text1={lang('channels_remove_qr_poster_title')}
        text2={lang('channels_remove_qr_poster_legend')}
        event={onDelete}
        isSubmitting={removing}
      />
    </div>
  )
}

export default QRCodeEdit
